import {
  querySemanticModelData as publicQuerySemanticModelData,
  getSemanticModel as publicGetSemanticModel,
  listSemanticModels as publicListSemanticModels,
} from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const querySemanticModelData: MaybeContext<
  BuildRESTFunction<typeof publicQuerySemanticModelData> &
    typeof publicQuerySemanticModelData
> = /*#__PURE__*/ createRESTModule(publicQuerySemanticModelData);
export const getSemanticModel: MaybeContext<
  BuildRESTFunction<typeof publicGetSemanticModel> &
    typeof publicGetSemanticModel
> = /*#__PURE__*/ createRESTModule(publicGetSemanticModel);
export const listSemanticModels: MaybeContext<
  BuildRESTFunction<typeof publicListSemanticModels> &
    typeof publicListSemanticModels
> = /*#__PURE__*/ createRESTModule(publicListSemanticModels);

export {
  FilterPrefixEnum,
  FilterConditionEnum,
  FieldTypeEnum,
  SortOrder,
} from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.universal.js';
export {
  SemanticModel,
  FieldValue,
  FieldValueValueOneOf,
  FieldFilters,
  Field,
  QuerySemanticModelDataRequest,
  DateTimeInterval,
  Sorting,
  FieldFilter,
  Paging,
  QuerySemanticModelDataResponse,
  DataRow,
  PagingMetadata,
  GetSemanticModelRequest,
  GetSemanticModelResponse,
  ListSemanticModelsRequest,
  ListSemanticModelsResponse,
  QuerySemanticModelDataOptions,
} from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.universal.js';
export {
  FilterPrefixEnumWithLiterals,
  FilterConditionEnumWithLiterals,
  FieldTypeEnumWithLiterals,
  SortOrderWithLiterals,
  QuerySemanticModelDataApplicationErrors,
  GetSemanticModelApplicationErrors,
  ListSemanticModelsApplicationErrors,
} from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.universal.js';
